import React, {useContext} from 'react';
import ScreenDesignerHoc from "../../../../../../../../HocHelpers/ScreenDesignerHoc";
import DefaultType from "../../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import TypeEntity from "../../../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";
import SelectType from "../../../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";
import {Divider, Typography} from "@material-ui/core";
import ScriptType from "../../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType";


const GeneralInformation = () => {
    const {
        screenValues,
        onChangeDefaultFields,
        screenTypeProps,
        scriptSuggestions
    } = useContext(ScreenDesignerContextNew);
    return (
        <>
            <DefaultType
                field={{
                    label: "Screen ID",
                    path: 'id',
                    type: "string",
                    autofocus: true,
                    required: true,
                }}
                setValue={onChangeDefaultFields}
                labelStyles={{width: '100px'}}
                fieldStyles={{width: '220px'}}
                values={screenValues}
            />
            <DefaultType
                field={{
                    label: "Name",
                    path: 'name',
                    type: "string",
                    autofocus: false,
                    required: true,
                    multiLanguage: true,
                }}
                setValue={onChangeDefaultFields}
                labelStyles={{width: '100px'}}
                fieldStyles={{width: '220px'}}
                values={screenValues}
            />
            <DefaultType
                field={{
                    label: "Description",
                    path: 'description',
                    type: "string",
                    autofocus: false,
                    required: false,
                }}
                setValue={onChangeDefaultFields}
                labelStyles={{width: '100px'}}
                fieldStyles={{width: '220px'}}
                values={screenValues}
            />
            <TypeEntity
                setValue={onChangeDefaultFields}
                labelStyles={{width: '100px'}}
                fieldStyles={{width: '220px'}}
                values={screenValues}
                field={{
                    label: "Application",
                    path: 'application',
                    entity: "application",
                    type: "entityExternal",
                    optLabel: "name",
                    autofocus: false,
                    required: false,
                    isArray: true,
                }}
            />
            <TypeEntity
                setValue={onChangeDefaultFields}
                labelStyles={{width: '100px'}}
                fieldStyles={{width: '220px'}}
                values={screenValues}
                field={{
                    label: "Tag",
                    path: 'tag',
                    entity: "systemTag",
                    type: "entityExternal",
                    autofocus: false,
                    required: false,
                    isArray: true
                }}
            />
            <TypeEntity
                setValue={onChangeDefaultFields}
                labelStyles={{width: '100px'}}
                fieldStyles={{width: '220px'}}
                values={screenValues}
                field={{
                    label: "Resolution",
                    path: 'resolution',
                    entity: "resolution",
                    type: "entityExternal",
                    returnType: "object",
                    optLabel: "name",
                    autofocus: false,
                    required: false,
                }}
            />
            {screenTypeProps.id === 'template' && (
                <TypeEntity
                    setValue={onChangeDefaultFields}
                    labelStyles={{width: '100px'}}
                    fieldStyles={{width: '220px'}}
                    values={screenValues}
                    field={{
                        label: "Group",
                        path: 'screenTemplateGroup',
                        entity: "screenTemplateGroup",
                        type: "entityExternal",
                        returnType: "object",
                        optLabel: "name",
                        autofocus: false,
                        required: false,
                    }}
                />
            )}
            {screenTypeProps.id === 'document' && (
                <div style={{marginTop: 10}}>
                    <div style={{marginTop: 5, marginBottom: 5}}>
                        <Typography style={{fontSize: 14}}>Print Settings</Typography>
                        <Divider/>
                    </div>

                    <div>
                        <SelectType
                            setValue={onChangeDefaultFields}
                            labelStyles={{width: '100px'}}
                            fieldStyles={{width: '220px'}}
                            values={screenValues}
                            field={{
                                label: "Orientation",
                                path: 'orientation',
                                type: "objSelect",
                                values: [
                                    {value: 'landscape', label: 'Landscape'},
                                    {value: 'vertical', label: 'Vertical'},
                                ]
                            }}
                        />
                        <SelectType
                            setValue={onChangeDefaultFields}
                            labelStyles={{width: '100px'}}
                            fieldStyles={{width: '220px'}}
                            values={screenValues}
                            field={{
                                label: "Scale",
                                path: 'scale',
                                type: "objSelect",
                                values: [
                                    {value: '1', label: '1'},
                                    {value: '0.9', label: '0.9'},
                                    {value: '0.8', label: '0.8'},
                                    {value: '0.7', label: '0.7'},
                                    {value: '0.6', label: '0.6'},
                                    {value: '0.5', label: '0.5'},
                                    {value: '0.4', label: '0.4'},
                                    {value: '0.3', label: '0.3'},
                                    {value: '0.2', label: '0.2'},
                                    {value: '0.1', label: '0.1'},
                                ]
                            }}
                        />
                    </div>
                </div>

            )}
            {(screenValues.version >= 3) && (
                <>
                    <ScriptType
                        labelStyles={{width: '100px'}}
                        fieldStyles={{width: '220px'}}
                        setValue={onChangeDefaultFields}
                        values={screenValues}
                        field={{
                            path: 'script',
                            label: "Script",
                            syntaxHighlight: "javascript",
                            entitySuggestion: scriptSuggestions,
                        }}
                    />
                </>
            )}

        </>
    );
};


export default ScreenDesignerHoc(GeneralInformation);